/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GetResolutionIndexResponse = core.serialization.object({
    index: core.serialization.number(),
});
